// extracted by mini-css-extract-plugin
export default {"countdown":"Uba-z","srOnly":"Vba-z"};